import React from 'react';
import Skills from '../../components/skills/Skills';

function SkillsPage() {
    return (
        <>
            <Skills />
        </>
    );
}

export default SkillsPage;
